import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useContainer } from '../../useContainer';
import { OrganizationApi } from '../../../api';
import { useAppDispatch, RootState } from '../../../store';
import { setFeatureConfig } from '../../../store/slices/feature-config.slice';
import { LocalStorage, ACCESS_TOKEN } from '../../../util/LocalStorage';
import { selectUserSub, selectOrganizationId, selectAuthInitialized } from '../../../store/slices/auth.slice';

const useHttpGetFeatureConfigsOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const dispatch = useAppDispatch();
    const storage: LocalStorage = useContainer(LocalStorage);
    const userSub = useSelector<RootState, string>(selectUserSub);
    const organizationId = useSelector<RootState, string>(selectOrganizationId);
    const isAuthInitialized = useSelector<RootState, boolean>(selectAuthInitialized);

    useEffect(() => {
        const accessToken = storage.get(ACCESS_TOKEN);

        if (!isAuthInitialized || !userSub || !accessToken || !organizationId) {
            return;
        }

        const { exec, abort } = organizationApi.getFeatureConfigs({
            onSuccess: res => dispatch(setFeatureConfig(res.body)),
            onError: err => console.error('Failed to fetch feature configs:', err),
        });

        exec();
        return abort;
    }, [isAuthInitialized, userSub, organizationId]);
};

export default useHttpGetFeatureConfigsOnMount;
